import React, { useState } from "react";
import SideBar from "../../components/vendor/SideBar";
import Header from "../../components/vendor/Header";

const DefaultLayout = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className="layout-container">
      <Header onToggleSidebar={toggleSidebar} />
      <div className="d-flex main-content">
        <SideBar show={showSidebar} onClose={() => setShowSidebar(false)} />
        <div className="content-area">
          <div className="">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
